import { useState, useCallback, ReactElement } from 'react';
import {
  InfoSt,
  MoreInfoBubbleSt,
  MoreInfoItemSt,
  MoreInfoTitleSt,
} from './SingleCookieSetting.css';
import { CloseIconSt } from 'app/shared/components/CookieDashboard/SingleCookieSetting/MoreInfoItem.css';
import { useTranslate } from 'app/shared/components/Translation/hooks/useTranslate/useTranslate';
import { useTrackingPageContext } from 'app/shared/components/PageWrapper/providers/TrackingPageProvider/TrackingPageProvider';
import { Close } from '@heycar-uikit/icons';

interface Props {
  infoItem: {
    item: string;
    bubble: string;
  };
}

const MoreInfoItem = ({ infoItem: { item, bubble } }: Props): ReactElement => {
  const { trackAction } = useTrackingPageContext();
  const [isOpen, setIsOpen] = useState(false);
  const translate = useTranslate();

  const toggleInfoItem = useCallback(() => {
    setIsOpen(isOpen => !isOpen);

    trackAction('cookieDashboard_cookieSettingDetailItem_click', {
      value: item,
      description: 'user clicks on the cookie settings info list item',
    });
  }, [item, trackAction]);

  return (
    <>
      <MoreInfoItemSt>
        <MoreInfoTitleSt>
          {translate({ id: item })}
          {bubble && <InfoSt onClick={toggleInfoItem} fontSize={28} />}
        </MoreInfoTitleSt>
        {bubble && (
          <MoreInfoBubbleSt isOpen={isOpen}>
            <strong>{translate({ id: item })}</strong>
            {translate({ id: bubble })}
            <CloseIconSt onClick={toggleInfoItem}>
              <Close fontSize={16} />
            </CloseIconSt>
          </MoreInfoBubbleSt>
        )}
      </MoreInfoItemSt>
    </>
  );
};

export { MoreInfoItem };
